<template>
	<details class="disclosure-details">
		<summary class="disclosure-summary">
			<slot name="title" />
			<!--      <IconChevronDown class="max-w-5 group-open:rotate-180 transition-transform" />-->
		</summary>
		<div class="disclosure-content">
			<slot name="content" />
		</div>
	</details>
</template>

<style scoped lang="scss">
.disclosure-details {
	border: 2px solid white;
}

.disclosure-summary {
	display: flex;
	justify-content: space-between;
	padding: 16px;

	&:hover {
		cursor: pointer;
		background: rgba(255, 255, 255, 0.1);
	}
}

.disclosure-content {
	padding: 16px;
}
</style>